/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import type { ReactNode } from "react";
import { Flags as BaseFlags } from "@superweb/flags";

const testingOnly = import.meta.env.FLEET_FORMS_ENV === "testing";

export const Flags = ({ children }: { children: ReactNode }) => {
  const showSingleDownloadButton = testingOnly;
  const enableDriverLicenseCountrySelection = true;
  const enableTestPhones = testingOnly;
  const enableNewOffer = Boolean(import.meta.env.FLEET_FORMS_NEW_BANNER);
  const enableTaxSystemWarning = testingOnly;

  return (
    <BaseFlags
      value={{
        "7fd41e03-8f0f-4153-b9ed-a0e613ed5500": Boolean(
          import.meta.env["FLEET_FORMS_VEHICLE_TYPES"],
        ),
        "aa814bf7-a087-4378-934f-9374140551cf": enableTestPhones,
        "7c942967-cab9-46e2-9d06-729692689aa0": enableTestPhones,
        "226d2703-0a1d-4796-941f-b69512e74bca": enableTestPhones,
        "3c8e074f-189c-4322-98d7-df3a553ccc61": enableTestPhones,
        "39102927-6a29-4430-9740-f9f54697ca6b": testingOnly,
        "54b9dc94-8033-49da-85e0-f02af3de7072": testingOnly,
        "981627bb-163a-4c31-80c2-5a8ab8585967": showSingleDownloadButton,
        "d6146bf2-3621-448f-9484-165709fc981d": showSingleDownloadButton,
        "ea22a0b5-1ea4-45b0-bdd1-b490a82fbb41": showSingleDownloadButton,
        "4a4da9be-2617-4e1d-9c21-f6c32d0a0427": testingOnly,
        "5548e5d7-e621-4d57-8e4a-95b276eaa8aa": testingOnly,
        "15167e81-cd28-4b1d-a31a-bca6e73739c4":
          enableDriverLicenseCountrySelection,
        "72a2ff75-7bc1-467b-b095-6a90152b36d5":
          enableDriverLicenseCountrySelection,
        "72217bf4-53f4-4b1a-a3bb-cc2c0fe15465":
          enableDriverLicenseCountrySelection,
        "994de453-45f8-442b-a47d-fe42d9fb8a61":
          enableDriverLicenseCountrySelection,
        "72a2ff75-7bc1-467b-b095-6a90152b36d6":
          enableDriverLicenseCountrySelection,
        "9e5e0e80-15c1-4180-8604-4044ec8b6bb0":
          enableDriverLicenseCountrySelection,
        "21fe53a9-0779-4dd0-a573-004cadc8c5d0":
          enableDriverLicenseCountrySelection,
        "561f48e6-9180-4133-9329-7adf38f05fd5":
          enableDriverLicenseCountrySelection,
        "7c260e68-0d50-46ef-9d3e-0f1855147e2d": enableNewOffer,
        "ccc86c7d-c0d6-401a-89d1-81ded0bffc2d": enableNewOffer,
        "a56ea566-bb27-4972-8314-80e52e67e9c0": enableNewOffer,
        "8ed16f3a-25d7-4455-8c23-a623eb0cd824": enableNewOffer,
        "979dfd25-18ad-4fd8-afed-ed5b3703c4b7": enableNewOffer,
        "58a1bd6b-2858-45da-9df8-cae1da2aac6c": enableNewOffer,
        "169ec9b9-0e61-4f2e-b8c5-13048eccca82": enableNewOffer,
        "27e3642e-9510-45a2-8dd7-69ddd4e47936": enableNewOffer,
        "fb7e3871-e396-4676-a5c2-2a2de4258d45": enableTaxSystemWarning,
        "b5260a1a-efb9-402c-9b69-c08fc51c79c6": enableTaxSystemWarning,
        "2f21b011-7f2b-47f4-a214-b465a4e1ffc5": enableTaxSystemWarning,
      }}
    >
      {children}
    </BaseFlags>
  );
};
